import React from 'react';
import './App.css';
import { BrowserRouter, Route } from 'react-router-dom';

// Components
import Checkout from './components/pay/checkout'
import Login from './components/login_logout/login'
import Register from './components/login_logout/register'
import Navbar from './components/homepage/navbar'
import Dashboard from './components/dashboard/home'
import Upload from './components/file-upload/upload'
import Home from './components/homepage/home'

// css
import 'bootstrap/dist/css/bootstrap.css'

function App() {

  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Route path="/" exact component={Home} />
        <Route path="/checkout" exact component={Checkout} />
        <Route path="/dashboard" exact component={Dashboard} />
      </BrowserRouter>
    </div>
  );
}

export default App